import { Disposable } from 'using-statement';
import IndigoApi from 'communication/IndigoApi';
import { v4 as uuid } from 'uuid';
import { LoggingService } from '@instinet-analytics/core-lib';
import { buildLogger, Logger } from '@instinet-analytics/core-lib';

export class StreamRequestBatch implements Disposable {
    public correlationId = uuid();
    private logger: Logger;

    public constructor(
        private indigoApi: IndigoApi,
        loggingService: LoggingService
    ) {
        this.logger = buildLogger('StreamRequestBatch', loggingService);
        indigoApi.beginStreamRequestBatch();
    }

    public dispose(): void {
        this.indigoApi.commitStreamRequestBatch();
    }
}
